import React from "react";
import { months } from "utils";

const holder = {
  closeFilterDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeFilterDropdownSelector)
    }
  }
};

export default {
  'RecurrenceSubscriptionDropdown.Wrapper.Header': async ({ isOpen, containerRef, isReadonly }, _, internalStateSetter) => {
    if (isReadonly) return;
    if (isOpen) return;
    await internalStateSetter('isOpen', true);

    let newContainerRef = containerRef;

    if (!containerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    document.addEventListener("mousedown", holder.closeFilterDropdownSelector);
  },

  'RecurrenceSubscriptionDropdown.Wrapper.DropdownWrapper.BorderWrapper.Weekdays.Day': ({ day, occurrenceValues }, outlet) => {
    if (occurrenceValues?.includes(day.id)) {
      outlet({ occurrenceValues: occurrenceValues?.filter(o => o !== day.id) })
    } else {
      outlet({ occurrenceValues: [...occurrenceValues, day.id] })
    }
  },
  'RecurrenceSubscriptionDropdown.Wrapper.DropdownWrapper.BorderWrapper.CalendarHeader.NextMonth': ({ selectedMonthIndex }, _, internalStateSetter) => {
    let newIndex = selectedMonthIndex === 12 ? 1 : selectedMonthIndex + 1;
    internalStateSetter({
      selectedMonthIndex: newIndex,
      dates: Array.from({ length: months.find(month => month.index === newIndex).daysCount }, (_, index) => index + 1)
    });
  },
  'RecurrenceSubscriptionDropdown.Wrapper.DropdownWrapper.BorderWrapper.CalendarHeader.PrevMonth': ({ selectedMonthIndex }, _, internalStateSetter) => {
    let newIndex = selectedMonthIndex === 1 ? 12 : selectedMonthIndex - 1;
    internalStateSetter({
      selectedMonthIndex: newIndex,
      dates: Array.from({ length: months.find(month => month.index === newIndex).daysCount }, (_, index) => index + 1)
    });
  },
  'RecurrenceSubscriptionDropdown.Wrapper.DropdownWrapper.BorderWrapper.Dates.Day': ({ date, occurrenceValues, frequency, selectedMonthIndex }, outlet) => {
    if (frequency === 'annually') {
      if (occurrenceValues.includes(`${selectedMonthIndex}/${date}`)) {
        outlet({ occurrenceValues: occurrenceValues.filter(d => d !== `${selectedMonthIndex}/${date}`) })
      } else {
        outlet({ occurrenceValues: [...occurrenceValues, `${selectedMonthIndex}/${date}`] })
      }
    } else {
      if (occurrenceValues.includes(date.toString())) {
        outlet({ occurrenceValues: occurrenceValues.filter(d => d !== date.toString()) })
      } else {
        outlet({ occurrenceValues: [...occurrenceValues, date.toString()] })
      }
    }
  },
}